/**
 * <kik-volume-pricing> — re-binds the cart-drawer "Volume pricing available"
 * hover/click behaviour for every new instance.
 *
 * The theme's SHTCartDrawerForm wires hover + click listeners to
 * .js-quantity-pricing-btn ONCE in its constructor. The AJAX cart update
 * swaps .js-cart-drawer-items' innerHTML, replacing each line item's
 * button + dropdown with brand-new DOM nodes that have no listeners.
 *
 * Wrapping the .product-quantity-pricing block in <kik-volume-pricing>
 * lets each new instance bind its own listeners on connectedCallback,
 * so the dropdown keeps working after every cart re-render.
 *
 * Preserves the original CSS contract:
 *   .quantity-pricing-btn.active + .quantity-pricing-content { visible }
 * (i.e. the button keeps the .active toggle, the content stays its sibling).
 */
class KikVolumePricing extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this.btn = this.querySelector('.js-quantity-pricing-btn');
    if (!this.btn) return;
    this._bound = true;

    if (window.matchMedia('(max-width: 1024px)').matches) {
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.btn.classList.toggle('active');
      });
    } else {
      this.addEventListener('mouseenter', () => this.btn.classList.add('active'));
      this.addEventListener('mouseleave', () => this.btn.classList.remove('active'));
    }

    this._docClickHandler = (e) => {
      if (!this.contains(e.target)) this.btn.classList.remove('active');
    };
    document.addEventListener('click', this._docClickHandler);
  }

  disconnectedCallback() {
    if (this._docClickHandler) document.removeEventListener('click', this._docClickHandler);
  }
}
customElements.define('kik-volume-pricing', KikVolumePricing);
